import React, {Component} from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Button } from 'antd';
import OtherVideo from '../otherVideo';
import OtherTable from "../common/otherTable";

class RealTime extends Component {
  state = {
    autoPlay: false,
    num: 0,
    options: {
      credits: {
        enabled: false
      },
      chart: {
        type: 'bar'
      },
      title: null,
      colors: [this.props.themeColor],
      xAxis: {
        lineWidth: 0,
        categories: [],
        crosshair: true,
        labels: {
          formatter() {
            let labelVal = this.value;
            let reallyVal = '';
            let lvl = labelVal.length;
            if (lvl > 1) {
              for (let i = 1; i <= lvl; i++) {
                reallyVal += labelVal.substr(i - 1, 1) + "<br/>";
              }
            }
            return reallyVal.substring(0, reallyVal.length - 5);
          }
        }
      },
      yAxis: {
        opposite: true,
        gridLineColor: 'rgba(61, 136, 241, 0.1)',
        title: null
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        bar: {
          dataLabels: {
            allowOverlap: false
          },
          pointWidth: 4
        }
      },
      series: [],
    }
  }

  changeNum = (type) => {
    this.setState({
      autoPlay: true,
      num: type === 'add' ? this.state.num + 1 : this.state.num - 1
    }, () => {
      //试题信息
      const interviewQuesVOs = this.props.paperInfo && this.props.paperInfo.interviewQuesVOs;
      this.props.handleClick(interviewQuesVOs[this.state.num] && interviewQuesVOs[this.state.num].questionId);
    });
  }

  handleTimeUpdate = (currentTime, res) => {
    const { result, i18n } = this.props;
    const data = res || result;
    const currentResult = data && data.data && data.data[this.state.num] || {};
    if(!(currentResult && currentResult["1"])) return false;
    if(!currentTime) return false;
    const index = (parseInt(currentTime) || 1) + "";
    const currentEmos = currentResult[index] && currentResult[index].emos || {};
    let categories = [], series = [];
    for(let i in currentEmos) {
      if(i !== 'attention') {
        categories.push(i18n.report.emotion[i]);
        series.push(currentEmos[i] || 0);
      }
    }
    if(categories.length > 0) {
      this.setState({
        options: {
          xAxis: {
            categories
          },
          series: [{
            name: i18n.report.summaryInfo3,
            data: series
          }]
        }
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if(nextProps.result && this.state.options.series.length === 0) {
      this.handleTimeUpdate(0.001, nextProps.result);
    }
  }

  render() {
    const { num, options, autoPlay } = this.state;
    const { i18n, summary, themeColor, videoUrl } = this.props;

    const columns = () => {
      return [{
        title: i18n.report.summaryInfo5,
        dataIndex: 'emotion',
        key: 'emotion',
        align: 'center'
      },{
        title: i18n.report.summaryInfo3,
        dataIndex: 'score',
        key: 'score',
        align: 'center'
      }, {
        title: i18n.report.summaryInfo4,
        dataIndex: 'strengthDesc',
        key: 'strengthDesc',
        align: 'center',
        render: (text, record) => <React.Fragment>
          {record.strength === 1 ? <strong>{text}</strong> : text}
        </React.Fragment>
      }];
    }

    const dataSource = () => {
      const arr = [];
      const emos = summary && summary.emos || {};
      for(let i in emos) {
        if(i !== 'attention') {
          arr.push({key: i, emotion: i18n.report.emotion[i], ...emos[i]});
        }
      }
      return arr;
    }

    return (
      <div className="realTime video-mobile-box">
        <h1 className="realTimeTitle" style={{color: themeColor}}>{i18n.result.realTimeInfo}</h1>
        <div className="realTimeTop">
          <div className="realTimeTopText">{i18n.report.questionNum.replace('${num}', num + 1)}<span>{i18n.report.questionTotal.replace('${num}', summary && summary.histogram && summary.histogram.series && summary.histogram.series.length || 0)}</span></div>
          <div className="questionBtn">
            <Button onClick={() => this.changeNum('less')} disabled={num <= 0}>{i18n.result.lastQue}</Button>
            <Button onClick={() => this.changeNum('add')} disabled={num === (summary && summary.histogram && summary.histogram.series && (summary.histogram.series.length - 1) || 0)} style={{backgroundColor: themeColor, borderColor: themeColor}} type="primary">{i18n.result.nextQue}</Button>
          </div>
        </div>
        <div className="questionText"><span>Q：</span>{summary && summary.histogram && summary.histogram.series && summary.histogram.series[num] && summary.histogram.series[num].questionName}</div>
        <OtherVideo handleTimeUpdate={this.handleTimeUpdate} videoUrl={videoUrl}
                    themeColor={themeColor} autoPlay={autoPlay} />
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
        />
        <OtherTable columns={columns()} dataSource={dataSource()} />
      </div>
    );
  }
}

export default RealTime;
